import { A } from 'hookrouter'
import { PDFDisplay } from 'components/PDFDisplay'
import React, { FC, useState, useEffect } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { Document, TemplateDocument, UrlParams } from 'types'
import { DocumentListDisplay } from '../DocumentListDisplay'
import { DuplicateTemplateSelector } from '../DuplicateTemplateSelector'
import { MoveTemplateSelector } from '../MoveTemplateSelector'
import { TemplateDeletionWarningModal } from 'components/TemplateDeletionWarningModal'
import { deleteTemplate, getPermissionsList } from 'state/async_actions'
import { useAppContext } from 'state/context'
import { usePermissions } from 'hooks/useCompanyManagers'
import { useProjectsForCompany } from 'hooks/useProjectsForCompany'
import { DuplicateTemplateToFolderSelector } from './DuplicateTemplateToFolderSelector'

export const MissingTemplateText = 'Please select a Template/Directory!'

type ProjectTemplateDisplayProps = UrlParams & {
  templateDocument?: TemplateDocument
  setActiveTemplate: (template: TemplateDocument | undefined) => void
}

export type ActiveDocument = Document | TemplateDocument | undefined

const editTemplateUrl = (
  companyId: number,
  projectId: number,
  templateDocumentId: number,
) =>
  `/company/${companyId}/project/${projectId}/templateDocument/${templateDocumentId}/edit`

export const ProjectTemplateDisplay: FC<ProjectTemplateDisplayProps> = ({
  companyId,
  projectId,
  templateDocument,
  setActiveTemplate,
}) => {
  const [, dispatch] = useAppContext()

  const [activeDocument, setActiveDocument] = useState<ActiveDocument>(
    templateDocument,
  )

  const [deleteTemplateDocument, setDeleteTemplate] = React.useState<
    (() => () => void) | undefined
  >()

  let userRoleType: any = 1;
const projectList = useProjectsForCompany(companyId)
const project:any = projectList.find((company:any) => company.id === projectId) || {}

  if (project.isCompanyManager)
    userRoleType = 1;
  else if (project.isProjectManager)
    userRoleType = 2;
  else if (project.isSuperForeman)
    userRoleType = 3;
  else if (project.isSubCordinator)
    userRoleType = 4;
  else if (project.isProjectCoordinator)
    userRoleType = 5;

useEffect(() => {
  if(companyId)
    getPermissionsList(dispatch, companyId, userRoleType)
}, [dispatch, projectId, userRoleType])

const permissionsList:any = usePermissions(userRoleType);

  const resetTemplateDeletionWarning = () => {
    setDeleteTemplate(undefined)
    setActiveTemplate(undefined)
  }

  const warnAndDeleteTemplate = () =>
    setDeleteTemplate(() => () => {
      if (templateDocument !== undefined) {
        deleteTemplate(dispatch, templateDocument.id)
      }
    })

  return (templateDocument ? (
    <div style={{paddingLeft: '5%'}}>
      {deleteTemplateDocument && (
        <TemplateDeletionWarningModal
          confirmAction={deleteTemplateDocument}
          updateParentState={resetTemplateDeletionWarning}
        />
      )}
      <h1>{templateDocument.title}</h1>
      <Row>
        <Col id="pdf-container">
          {activeDocument && activeDocument.fileUrl ? (
            <PDFDisplay document={activeDocument} />
          ) : (
            <p>
              Please select a document (not a template) from the list of
              documents.
            </p>
          )}
        </Col>
        <Col>
          {(permissionsList?.template_document?.copy_from_one_project_to_another && project?.status == 'active') && <DuplicateTemplateSelector
            projectId={projectId}
            companyId={companyId}
            templateDocumentId={templateDocument.id}
          />
}
{(permissionsList?.template_document?.can_duplicate_to_directory && project?.status == 'active') && 
<DuplicateTemplateToFolderSelector
            projectId={projectId}
            companyId={companyId}
            templateDocumentId={templateDocument.id}
          />  } 
          {(permissionsList?.template_document?.move_template_to_folder && project?.status == 'active') && <MoveTemplateSelector
            projectId={projectId}
            companyId={companyId}
            templateDocumentId={templateDocument.id}
          />
}
          {(permissionsList?.template_document?.can_edit && project?.status == 'active') && <A
            href={editTemplateUrl(companyId, projectId, templateDocument.id)}
            className="btn btn-primary btn-block btn-icon-plus"
            role="button">
            Edit Template
          </A>
}
          {(permissionsList?.template_document?.can_delete && project?.status == 'active') && <Button
            variant="primary"
            className="btn btn-primary btn-block"
            onClick={warnAndDeleteTemplate}>
            Delete Template
          </Button>
}
          <h2> Documents: </h2>
          <DocumentListDisplay
            activeDocument={activeDocument}
            setActiveDocument={setActiveDocument}
            templateDocument={templateDocument}
            permissionsList = {permissionsList}
          />
        </Col>
      </Row>
    </div>
  ) : null
  // (
  //   <h1>{MissingTemplateText}</h1>
  // )
  )
}
